import { Col, Row } from 'antd';
import PictureAssignment from 'components/Image/PictureAssignment';
import TextEditor from 'components/TextEditor';
import AudioRecorder from 'features/AudeoRecorderNew';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import COLOR from 'utils/constants/color';
import ModalMenu from 'components/Modals';
import { Label } from '@mui/icons-material';

const StudentPictureAssignment = (props) => {
  const navigate = useNavigate();
  const { question, selections, isTablate } = props?.states;
  const { handleImageSelect, setOpenImageViewModal, trenacriptAudio, setButtonDisabled, handleAdditionalImages } =
    props?.funcObj;
  const isNewSubmission = props?.isNewSubmission || false;
  const [imageModal, setImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const currentAdditionalImages = selections[question?.oldIndex]?.additionalImages || [];

  const allImages = [];
  if (question?.pictures) {
    if (Array.isArray(question.pictures)) {
      allImages.push(...question.pictures);
    } else {
      allImages.push(question.pictures);
    }
  }
  if (question?.additionalPictures && Array.isArray(question.additionalPictures)) {
    allImages.push(...question.additionalPictures);
  }

  return (
    <div>
      {allImages.length > 0 && (
        <>
          {allImages.length === 1 ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 25
              }}
            >
              <Images
                className="cursor-zoomIn gradeBook-answer-image-width-height"
                src={allImages[0]}
                onClick={() => {
                  setSelectedImage(allImages[0]);
                  setImageModal(true);
                }}
              />
              <ModalMenu 
                type="imageModal" 
                image={allImages[0]} 
                open={imageModal} 
                close={() => {
                  setImageModal(false);
                  setSelectedImage(null);
                }} 
              />
            </div>
          ) : (
            <div className="imgAssignStud">
              {allImages.map((imageUrl, imgIndex) => (
                <div key={imgIndex}>
                  <Images
                    className="cursor-zoomIn"
                    src={imageUrl}
                    onClick={() => {
                      setSelectedImage(imageUrl);
                      setImageModal(true);
                    }}
                  />
                </div>
              ))}
              <ModalMenu 
                type="imageModal" 
                image={selectedImage || allImages[0]} 
                open={imageModal} 
                close={() => {
                  setImageModal(false);
                  setSelectedImage(null);
                }} 
              />
            </div>
          )}
        </>
      )}
      {question.categoryType === 'Image' ? (
        <div className="imgAssignStudAnsUpr">
        <StyledLabel>
          Your answer
          <MaxImagesInfo>Max {question?.studentCanUploadImages || 6} images can be uploaded</MaxImagesInfo>
        </StyledLabel>
        <PictureAssignment
          source={
            !!selections[question?.oldIndex]?.imageUrl
              ? selections[question?.oldIndex]?.imageUrl
              : ''
          }
          additionalImages={currentAdditionalImages}
          handleAdditionalPictures={(images) => {
            if (handleAdditionalImages) {
              handleAdditionalImages(question?.oldIndex, images, question.categoryType);
            }
          }}
          style={{
            marginTop: selections[question?.oldIndex]?.imageUrl
              ? window.innerWidth >= 1024
                ? '130px'
                : '85px'
              : '',
          }}
          maxImagesUpload={question.studentCanUploadImages}
          imageClassName={`assignment-image ${isTablate ? 'assignmentTabImg' : ''}`}
          containerClassName="assignment-ebook"
          type={'student'}
          handlePicture={(url) =>
            handleImageSelect(question?.oldIndex, '', url, 'picture', question.categoryType)
          }
          setButtonDisabled={setButtonDisabled}
          isNewSubmission={isNewSubmission}
        />
        </div>
      ) : question.categoryType === 'ImageAndText' ? (
        <>
          <StyledLabel>
            Your answer 
            <MaxImagesInfo>Max {question.studentCanUploadImages} images can be uploaded</MaxImagesInfo>
          </StyledLabel>
          <PictureAssignment
            source={
              !!selections[question?.oldIndex]?.imageUrl
                ? selections[question?.oldIndex]?.imageUrl
                : ''
            }
            maxImagesUpload={question.studentCanUploadImages}
            additionalImages={currentAdditionalImages}
            handleAdditionalPictures={(images) => {
              if (handleAdditionalImages) {
                handleAdditionalImages(question?.oldIndex, images, question.categoryType);
              }
            }}
            // style={{ marginTop: '50px' }}
            imageClassName="assignment-image"
            type={'student'}
            handlePicture={(url) =>
              handleImageSelect(question?.oldIndex, '', url, 'picture', question.categoryType)
            }
            setButtonDisabled={setButtonDisabled}
            isNewSubmission={isNewSubmission}
          />
          <Row gutter={[0, 24]}>
            <Col span={24}>
              <TextEditor
                handleChange={(data) =>
                  handleImageSelect(question?.oldIndex, data, '', 'picture', question.categoryType)
                }
                value={
                  !!selections[question?.oldIndex]?.answer
                    ? selections[question?.oldIndex]?.answer
                    : ''
                }
              />
            </Col>
          </Row>
        </>
      ) : question.categoryType === 'Text' ? (
        <Row style={{ marginTop: '10px' }} gutter={[0, 24]}>
          <Col span={24}>
            <TextEditor
              handleChange={(data) =>
                handleImageSelect(question?.oldIndex, data, '', 'picture', question.categoryType)
              }
              value={
                !!selections[question?.oldIndex]?.answer
                  ? selections[question?.oldIndex]?.answer
                  : ''
              }
            />
          </Col>
        </Row>
      ) : question.categoryType === 'Audio' ? (
        <AudioRecorder
          maxTime={question.duration || 60}
          handleAudio={(url) => {
            handleImageSelect(question?.oldIndex, url, '', 'picture', question.categoryType);
            trenacriptAudio(url);
          }}
          refresh={() => navigate(-1)}
          source={
            !!selections[question?.oldIndex]?.answer ? selections[question?.oldIndex]?.answer : ''
          }
          setButtonDisabled={setButtonDisabled}
        />
      ) : question.type === 'audioToImage' ? (
        <div className="imgAssignStudAnsUpr">
        <StyledLabel>
          Your answer
          <MaxImagesInfo>Max {question.studentCanUploadImages} images can be uploaded</MaxImagesInfo>
        </StyledLabel>
        <PictureAssignment
          source={
            !!selections[question?.oldIndex]?.imageUrl
              ? selections[question?.oldIndex]?.imageUrl
              : ''
          }
          additionalImages={currentAdditionalImages}
          handleAdditionalPictures={(images) => {
            if (handleAdditionalImages) {
              handleAdditionalImages(question?.oldIndex, images, 'Image');
            }
          }}
          style={{
            marginTop: selections[question?.oldIndex]?.imageUrl
              ? window.innerWidth >= 1024
                ? '130px'
                : '85px'
              : '',
          }}
          maxImagesUpload={question.studentCanUploadImages}
          imageClassName={`assignment-image ${isTablate ? 'assignmentTabImg' : ''}`}
          containerClassName="assignment-ebook"
          type={'student'}
          handlePicture={(url) =>
            handleImageSelect(question?.oldIndex, '', url, 'audioToImage', 'Image')
          }
          setButtonDisabled={setButtonDisabled}
          isNewSubmission={isNewSubmission}
        />
        </div>
      ) : null}
    </div>
  );
};

export default StudentPictureAssignment;

const Images = styled.img`
  background-color: ${COLOR.white};
  box-shadow:
    0 10px 20px rgba(0, 0, 0, 0.19),
    0 6px 6px rgba(0, 0, 0, 0.23);
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
  border-radius: 8px;
  height: 100%;
  width: auto;
  max-width: 250px;
  max-height: 250px;
`;

const ImagesScrollContainer = styled.div`
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: scroll;
    gap: 15px;
    padding: 10px 0;
    margin-top: 25px;
    width: 100%;
    min-height: 200px;
    max-height: 400px;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    
    &::-webkit-scrollbar {
        width: 8px;
        -webkit-appearance: none;
        display: block !important;
    }
    
    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1);
    }
    
    &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
        
        &:hover {
            background: #555;
        }
    }
    &::-webkit-scrollbar:vertical {
        width: 8px;
    }
`;

const StyledLabel = styled.label`
    display: block;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin-top: 12px;
    margin-bottom: 12px;
    line-height: 1.5;
`;

const MaxImagesInfo = styled.span`
    color: #1890ff;
    font-weight: 500;
    background-color: #e6f7ff;
    padding: 2px 8px;
    border-radius: 4px;
    margin: 0 4px;
`;

